import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '@/views/Home.vue';
import HomeWindow from '@/views/home/HomeWindow.vue';
import User from '@/views/user/User.vue';
import UserList from '@/views/user/UserList.vue';
import Project from '@/views/project/Project.vue';
import TargetList from '@/views/target/TargetList.vue';
import ProjectList from '@/views/project/ProjectList.vue';
import TargetDetails from '@/views/target/TargetDetails.vue';
import ProjectDetails from '@/views/project/ProjectDetails.vue';
import LoaderGeneratorLog from "@/views/LoaderGeneratorLog.vue";
import Login from '@/views/Login.vue';
const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        children: [
            {
                path: '/',
                name: 'HomeWindow',
                component: HomeWindow,

            },
            {
                path: 'user',
                name: 'User',
                component: User,
                redirect: { name: 'UserList' },
                children: [
                    {
                        path: '',
                        name: 'UserList',
                        component: UserList
                    },

                ],
            },
            {
                path: 'project',
                name: 'Project',
                component: Project,
                redirect: { name: 'ProjectList' },
                children: [
                    {
                        path: '',
                        name: 'ProjectList',
                        component: ProjectList
                    },
                    {
                        path: ':projId',
                        name: 'ProjectDetails',
                        component: ProjectDetails,
                        redirect: { name: 'TargetList' },
                        children: [
                            {
                                path: '',
                                name: 'TargetList',
                                component: TargetList,
                            },
                            {
                                path: ':targetId',
                                name: 'TargetDetails',
                                component: TargetDetails,
                            }
                        ],
                    },
                ],
            },
            {
                path: 'generatorLog',
                name: 'generatorLog',
                component: LoaderGeneratorLog,
            },
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach(async (to, from, next) => {
    const isAuthenticated = localStorage.getItem("at_l_token") !== null;
    if (!isAuthenticated && to.name !== 'login') {
        next({ name: "login" });
    } else if (isAuthenticated && to.name === 'login') {
        next({ name: "HomeWindow" });
    } else {
        next();
    }
});

export default router;
